import React, { useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { Create, FileCopySharp } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import moment from 'moment';
//iconos
import { Add } from '@material-ui/icons';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTableV2.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsFindBy, wsPost } from 'services/WService.js';

//modal
import Modal from './Modal';
import Modal2 from './ModalChangeSeller';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { wsUpdate } from 'services/WService';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
};
const useStyles = makeStyles(styles);

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Periodo', accessor: 'Periodo', width: 100 },
  { Header: 'Código vendedor', accessor: 'SlpCode', width: 160 }, // SlpCode preguntar
  { Header: 'Nombre Vendedor', accessor: 'SlpName', width: 240 },

  { Header: 'Clientes Efectivos', accessor: 'ClientesEfectivos', width: 165, excelEnabled: false },
  { Header: 'Clientes Efectivos', accessor: 'ClientesEfectivos_string', hidden: true },

  { Header: 'Número de Pedidos', accessor: 'NumeroPedidos', width: 180, excelEnabled: false },
  { Header: 'Número de Pedidos', accessor: 'NumeroPedidos_string', hidden: true },

  { Header: 'Item por pedido', accessor: 'ItemXPedido', width: 150, excelEnabled: false },
  { Header: 'Item por pedido', accessor: 'ItemXPedido_string', hidden: true },

  { Header: 'TMLUC', accessor: 'TMLUC', excelEnabled: false },
  { Header: 'TMLUC', accessor: 'TMLUC_string', hidden: true },

  { Header: 'Galletas', accessor: 'Galletas', excelEnabled: false },
  { Header: 'Galletas', accessor: 'Galletas_string', hidden: true },

  { Header: 'Chocolates', accessor: 'Chocolate', width: 110, excelEnabled: false },
  { Header: 'Chocolates', accessor: 'Chocolate_string', hidden: true },

  { Header: 'Cafe', accessor: 'Cafe', excelEnabled: false },
  { Header: 'Cafe', accessor: 'Cafe_string', hidden: true },

  { Header: 'CuotaSolesTotal', accessor: 'CuotaSolesTotal', width: 160, excelEnabled: false },
  { Header: 'CuotaSolesTotal', accessor: 'CuotaSolesTotal_string', hidden: true },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Colgate(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal();
  const [model2, setOpen2] = useModal();
  const [notify, showNotify] = useToasty();
  const [cuotas, setCuotas] = useState([]);
  const [valueSearch, setValueSearch] = useState({});
  const [currentPeriod, setCurrentPeriod] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);

  const handleChange = (id, field, value) => {
    const index = cuotas.findIndex((item) => item.id == id);
    cuotas[index][field] = value;
    setCuotas([...cuotas]);
  };
  
  async function loadCuotas(filter) {
    setDataLoading(true);
    let response = await wsFindBy('sale/seller-quote-winter', filter);
    setDataLoading(false);
    if (response.success) setCuotas(response.data);
  }
  
  async function updateCuota(id, field, value) {
    setDataLoading(true);
    let response = await wsUpdate('sale/seller-quote-winter', id, { [field]: value });
    setDataLoading(false);
    if (response.success) {
      showNotify(response.message);
      console.log('Datos devueltos: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
    }
  }
  
  async function transferirRegistros(sourcePeriodo, targetPeriodo) {
    setDataLoading(true);
    let response = await wsPost('sale/seller-quote-winter/transferir-registros', {
      SourcePeriodo: sourcePeriodo,
      TargetPeriodo: targetPeriodo,
    });
    setDataLoading(false);

    if (response.success) {
      showNotify(response.message);
      console.log('Transferencia exitosa: ', response.data);
      loadCuotas(valueSearch);
    } else {
      showNotify(response.message, 'error');
      console.error('Error al transferir registros: ', response);
    }
  }

  const handleFilterChange = (value) => {
    const period = parseInt(moment(value.Periodo).format('YYYYMM'), 10);
    setCurrentPeriod(period);
  };

  return (
    <GridContainer>
      <Toasty action={notify} />
      {model.open ? (
        <Modal
          model={model}
          setOpen={setOpen}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}
      {model2.open ? (
        <Modal2 
          model={model2}
          setOpen={setOpen2}
          showNotify={showNotify}
          reload={() => loadCuotas(valueSearch)}
        />
      ) : undefined}

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_STORE}
              component={
                <CardIcon color="primary">
                  <FileCopySharp style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de cuotas de Vendedores {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <FilterCustom
              getFilter={loadCuotas}
              getValueSearch={(value) => {
                setValueSearch(value);
                handleFilterChange(value);
              }}
              date
              dateType="month"
              labelDate="Periodo"
              dateField="Periodo"
              sellerCode
            />
            <Button
              color="danger"
              onClick={() => {
                const sourcePeriod = moment(currentPeriod.toString(), "YYYYMM").subtract(1, "month").format("YYYYMM");
                transferirRegistros(Number(sourcePeriod), currentPeriod);
              }}>
              Inicializar cuotas de vendedores
            </Button>
            <ReactTable
              excelName="cuotas_de_proveedor"
              formatDate="DD-MM-YYYY"
              defaultWidth={1700}
              columns={columns}
              data={cuotas.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color={props.themeContext.buttonColorWarning}
                          onClick={() => setOpen2(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_DELETED}
                      >
                        <ButtonDelete
                          entity="sale/seller-quote-winter"
                          id={item.id}
                          reload={() => {
                            setDataLoading(true);
                            loadCuotas(valueSearch).then(() => setDataLoading(false));
                          }}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  Periodo: item.Periodo,
                  SlpCode: item.SlpCode,
                  SlpName: item.SlpName,
                  CardName: item.CardName,
                  ClientesEfectivos_string: item.ClientesEfectivos,
                  NumeroPedidos_string: item.NumeroPedidos,
                  ItemXPedido_string: item.ItemXPedido,
                  TMLUC_string: item.TMLUC,
                  Galletas_string: item.Galletas,
                  Chocolate_string: item.Chocolate,
                  Cafe_string: item.Cafe,
                  CuotaSolesTotal_string: item.CuotaSolesTotal,
                  ClientesEfectivos: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.ClientesEfectivos}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="ClientesEfectivos"
                        margin="normal"
                        value={item.ClientesEfectivos || ''}
                        onChange={(e) => handleChange(item.id, 'ClientesEfectivos', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'ClientesEfectivos', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  NumeroPedidos: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.NumeroPedidos}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="NumeroPedidos"
                        margin="normal"
                        value={item.NumeroPedidos || ''}
                        onChange={(e) => handleChange(item.id, 'NumeroPedidos', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'NumeroPedidos', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  ItemXPedido: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.ItemXPedido}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="ItemXPedido"
                        margin="normal"
                        value={item.ItemXPedido || ''}
                        onChange={(e) => handleChange(item.id, 'ItemXPedido', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'ItemXPedido', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  TMLUC: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.TMLUC}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="TMLUC"
                        margin="normal"
                        value={item.TMLUC || ''}
                        onChange={(e) => handleChange(item.id, 'TMLUC', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'TMLUC', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  Galletas: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.Galletas}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="Galletas"
                        margin="normal"
                        value={item.Galletas || ''}
                        onChange={(e) => handleChange(item.id, 'Galletas', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'Galletas', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  Chocolate: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.Chocolate}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="Chocolate"
                        margin="normal"
                        value={item.Chocolate || ''}
                        onChange={(e) => handleChange(item.id, 'Chocolate', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'Chocolate', e.target.value)}
                      />
                    </AllowedGuard>
                  ),

                  Cafe: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.Cafe}
                    >
                    <TextField
                      fullWidth
                      type="number"
                      name="Cafe"
                      margin="normal"
                      value={item.Cafe || ''}
                      onChange={(e) => handleChange(item.id, 'Cafe', e.target.value)}
                      onBlur={(e) => updateCuota(item.id, 'Cafe', e.target.value)}
                    />
                    </AllowedGuard>
                  ),
                  CuotaSolesTotal: (
                    <AllowedGuard
                      permission={ConstantPermissions.SALE_CUSTOMER_PROVIDER_QUOTES_UPDATE}
                      component={item.CuotaSolesTotal}
                    >
                      <TextField
                        fullWidth
                        type="number"
                        name="CuotaSolesTotal"
                        margin="normal"
                        value={item.CuotaSolesTotal || ''}
                        onChange={(e) => handleChange(item.id, 'CuotaSolesTotal', e.target.value)}
                        onBlur={(e) => updateCuota(item.id, 'CuotaSolesTotal', e.target.value)}
                      />
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
